import { useState, type FormEvent } from 'react';
import { apiFetch } from '../lib/api';

export function InviteUser() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setMessage(null);
    setError(null);
    setSubmitting(true);

    try {
      await apiFetch('/api/invite', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim() }),
      });
      setMessage(
        `Invitation sent to ${email}. They'll get an email with a link to set their password and sign in — no separate password reset needed.`,
      );
      setEmail('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invite failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="page">
      <h1>Invite a user</h1>
      <p className="muted">
        Sends a Supabase invitation email. Requires the caller to have an
        <code> admin </code> role in <code>app_metadata</code>.
      </p>
      <form onSubmit={onSubmit} className="auth-card" noValidate>
        <label>
          Email
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        {error && <p className="form-error" role="alert">{error}</p>}
        {message && <p className="form-success" role="status">{message}</p>}
        <button type="submit" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send invite'}
        </button>
      </form>
    </section>
  );
}
